/**
 * EmberPOS pricing display configuration.
 * Council Decision #10: B2B paid day 1 with Starter, Professional, and
 * Enterprise tiers. Checkout price IDs remain server-owned so the renderer
 * cannot drift from the canonical payment routes.
 */

const APP_PRICING = {
  'fire-pos': {
    name: 'EmberPOS',
    model: 'b2b',
    // Must equal the App Store intro offer on all three subscriptions (FREE_TRIAL ONE_WEEK, ASC 2026-10-27)
    // and the server's new-account trial (server/routes/tenants.js): the sign-in CTA shows this number.
    trialDays: 7,
    tiers: [
      {
        id: 'starter',
        label: 'Starter',
        price: 49,
        interval: 'month',
        features: ['Single location', 'Full POS features', 'Unlimited menu items', 'Basic reporting', 'Email support'],
      },
      {
        id: 'professional',
        label: 'Professional',
        price: 99,
        interval: 'month',
        features: ['Up to 3 locations', 'Full POS + Kitchen Display', 'Advanced analytics', 'Inventory management', 'Integration APIs', 'Priority support'],
        recommended: true,
      },
      {
        id: 'enterprise',
        label: 'Enterprise',
        price: 199,
        interval: 'month',
        features: ['Unlimited locations', 'Full feature suite', 'Custom integrations', 'Dedicated account manager', 'On-site training', 'SLA guarantees'],
      },
    ],
    annualDiscount: 0.2,
  },
};

export function getAppPricing(appId) {
  return APP_PRICING[appId] || null;
}

export default APP_PRICING;
